
const getTitle = (location, callback) => {
  const searchParams = new window.URLSearchParams(location.search);
  if (searchParams.has('title')) return;
  fetch('https://global-test.np.oxfordonlinepractice.com/api/products/productids')
    .then((response) => {
      if (response.ok) return response.json();
      return Promise.reject(response.status);
    })
    .then((json) => {
      const courseKey = searchParams.get('course');
      const courseTitle = json.data[courseKey];

      if (courseTitle === undefined) return;
      searchParams.set('title', courseTitle);
      window.location.search = searchParams;
      callback(courseTitle);
    })
    .catch(response => console.error(response)); // 404
};

export default getTitle;




// WEBPACK FOOTER //
// ./src/components/getTitle/getTitle.js